module.exports = __webpack_public_path__ + "static/media/content_copy.251fcd32.svg";